module.exports = function() {
  return new Worker(__webpack_public_path__ + "644b035fad5b347fc738.worker.js");
};